import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable()
export class OverlayService {
	overlayData: Observable<any>;
	private _overlayData: BehaviorSubject<OverlayData>;

	refreshData: Observable<any>;
	private _refreshData: BehaviorSubject<OverlayData>;

	constructor() {
		this._overlayData = <BehaviorSubject<any>>new BehaviorSubject([]);
		this.overlayData = this._overlayData.asObservable();
		this._refreshData = <BehaviorSubject<any>>new BehaviorSubject([]);
		this.refreshData = this._refreshData.asObservable();
		this.updateOverlay(false);
	}

	updateOverlay(active, text?, type?) {
		const overlayData: OverlayData = { active: active, text: text ? text : 'Loading...', type: type ? type : 'bar' };
		this._overlayData.next(overlayData);
	}

	updateRefresh(active, text?, type?) {
		const refreshData: OverlayData = {
			active: active,
			text: text ? text : 'Updating Component Preview...',
			type: type ? type : 'refresh'
		};
		this._refreshData.next(refreshData);
	}
}

export interface OverlayData {
	active: boolean;
	text: string;
	type: string;
}
